import { identify, makeRequest, Service } from 'utils/http';

export async function getAllTemplatesApi() {
  return makeRequest(Service.getAllTemplates(await identify()));
}
